module.exports = __webpack_public_path__ + "img/FAQs_Desktop.jpg";